/* eslint-disable no-unused-expressions */
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button } from '@mui/material';
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import * as React from 'react';
import Axios from '../../Axios';
import Deleter from '../helper/Deleter';
export default function NotificationChannel(props) {
    const [notificationChannel, setNotificationChannel] = React.useState(props.notificationChannel)
    const [name, setName] = React.useState(props.notificationChannel.name)
    const [code, setCode] = React.useState(props.notificationChannel.chat_id)
    const basicName = props.notificationChannel.name
    const basicCode = props.notificationChannel.chat_id
    const sendEditRequest = () => {
        if(name && code) {
            let notificationChannelData = new FormData()
            notificationChannelData.append('_method', 'PUT')
            name ? notificationChannelData.append('name', name) : ''
            code ? notificationChannelData.append('chat_id', code) : ''
            Axios.post(`notification-channels/${props.notificationChannel.id}`, notificationChannelData)
            .then(res => {
                onChanged(res.data.message, 'success')
            })
            .catch(error => {
                onChanged(error.response.data.message, 'error')
            })
        }
    }
    
    const onChanged = (data, type) => {
        props.onChanged(data, type);
    };
    return(
        <TableRow
              className="patients-table-body-row"
              key={notificationChannel.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell scope="row">
                   <section className="procedures-category">
                        <div className=''>
                            <div className="">
                                <div className="">
                                    <Box className="input-box">
                                        <TextField
                                            value={name}
                                            id="name"
                                            name="name"
                                            variant="outlined"
                                            color="secondary"
                                            onChange={(e) => setName(e.target.value)}
                                            error={!name}
                                            helperText={!name ? 'name is required' : ''}
                                            className="title-field"
                                        />
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </section> 
              </TableCell>
              <TableCell scope="row">
                   <section className="procedures-category">
                        <div className=''>
                            <div className="">
                                <div className="">
                                    <Box className="input-box">
                                        <TextField
                                            value={code}
                                            id="code"
                                            name="code"
                                            variant="outlined"
                                            color="secondary"
                                            onChange={(e) => setCode(e.target.value)}
                                            error={!code}
                                            helperText={!code ? 'code is required' : ''}
                                            className="title-field"
                                        />
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </section> 
              </TableCell>
              <TableCell align="right">
                <div className="flex items-center justify-end gap-1">
                    <Button variant='contained' disabled={(name === basicName && code === basicCode) || !name || !code} onClick={sendEditRequest}>
                        <EditOutlinedIcon
                            className="cursor-pointer"
                        />
                    </Button>
                    <Deleter route="notification-channels" id={notificationChannel.id} title='Delete Notification Channel' description={`are you sure you want delete ${notificationChannel.name}`} onDeleted={onChanged}/>
                </div>
              </TableCell>
            </TableRow>
        
    )
}